import { render, staticRenderFns } from "./myEvaOfMoral.vue?vue&type=template&id=81812eb4&scoped=true&"
import script from "./myEvaOfMoral.vue?vue&type=script&lang=js&"
export * from "./myEvaOfMoral.vue?vue&type=script&lang=js&"
import style0 from "./myEvaOfMoral.vue?vue&type=style&index=0&id=81812eb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81812eb4",
  null
  
)

export default component.exports